// The Sky News video the server queues as "now playing" whenever the queue runs dry.
// It is a placeholder rather than a song: the TV shows the venue logo in its place, and
// the patron and owner screens say the queue is empty. Also in src/config/liveVideos.json.
export const FILLER_YOUTUBE_ID = '9Auq9mYxFEE';

export const isFillerVideo = (video?: { thirdPartyId?: string } | null) =>
  !!video && video.thirdPartyId === FILLER_YOUTUBE_ID;
